import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {
  Container, Typography
} from "@mui/material";
import config from "../../config";
import i18n from "../../i18n";
import TypeOfCertificates from "./TypeOfCertificates/TypeOfCertificates";
import ContactRoles from "./ContactRoles/ContactRoles";
class Airtrace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab:props.params?.tabId || 'type_of_certificates',
      tabId: props.params?.tabId}
    
  }
  componentDidUpdate(prevProps) {
    if (this.state.tabId !== this.props.params.tabId) {
      this.setState({ tabId: this.props.params.tabId ,currentTab:this.props.params.tabId});
    }
  }


  render() {
    return (
    <Container maxWidth="xxl">
        <Helmet>
          <title>
            {" "}
            {i18n.t("settings")} | {config.APPLICATION_NAME}{" "}
          </title>
        </Helmet>
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={this.state?.currentTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={(event, newValue)=>{
            this.setState({
                currentTab:newValue
            })
            this.props.navigate(`/settings/view/${newValue}`)
          }} aria-label="lab API tabs example">
            <Tab label={i18n.t('type_of_certificates')} value={'type_of_certificates'} />
            <Tab label={i18n.t('contact_roles')} value={'contact_roles'} />
          </TabList>
        </Box>
        <TabPanel value={"type_of_certificates"} sx={{padding:'10px 0'}}><TypeOfCertificates/></TabPanel>
        <TabPanel value={'contact_roles'} sx={{padding:'10px 0'}}><ContactRoles/></TabPanel>
      </TabContext>
    </Box>
      </Container>
    )
  }
}

// Wrap and export
export default function (props) {
  const navigate = useNavigate();
  const params = useParams();

  return <Airtrace {...props} navigate={navigate} params={params} />;
}
